/** Display format for a filter's chosen range, e.g. "Sep 3, 2026". */
export const FILTER_DATE_FORMAT = "MMM D, YYYY"

/**
 * The quick-select row offered above every date-range filter. Each preset resolves against
 * "today" when it is clicked rather than at module load, so a tab left open overnight still
 * offers the right window.
 *
 * `shortLabel*` is what a narrow surface shows — the phone filter sheet, and any pill that
 * displays the matched preset instead of its dates.
 */
export const DATE_RANGE_PRESETS = [
  {
    key: "next_7_days",
    labelKey: "filters.preset_next_7_days",
    labelDefault: "Next 7 Days",
    shortLabelKey: "filters.preset_next_7_days_short",
    shortLabelDefault: "Next 7 Days",
    getRange: (today) => [today, today.add(6, "day")]
  },
  {
    key: "next_30_days",
    labelKey: "filters.preset_next_30_days",
    labelDefault: "Next 30 Days",
    shortLabelKey: "filters.preset_next_30_days_short",
    shortLabelDefault: "Next 30 Days",
    getRange: (today) => [today, today.add(29, "day")]
  },
  {
    key: "rest_of_year",
    labelKey: "filters.preset_rest_of_year",
    labelDefault: "Rest of This Year",
    shortLabelKey: "filters.preset_rest_of_year_short",
    shortLabelDefault: "Rest of Year",
    getRange: (today) => [today, today.endOf("year")]
  }
]

/**
 * How a filter panel is framed:
 *  - `dropdown` draws its own card and lets antd position it against the trigger
 *  - `inline` fills whatever already frames it — a bottom sheet, an accordion section, or a
 *    dropdown that supplies its own card
 */
export const FILTER_PANEL_VARIANTS = { DROPDOWN: "dropdown", INLINE: "inline" }
